/* eslint-disable import/no-unresolved */
import PropTypes from 'prop-types';
import { Container } from 'react-bootstrap';

import { Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

const GALLERY_SETTINGS = {
  modules: [Navigation],
  navigation: true,
  loop: true,
  spaceBetween: 16,
  breakpoints: {
    960: {
      slidesPerView: 3,
    },
  },
};

export const ThreePartSlider = ({ images, alt, onClick, className = '', children }) => {
  return (
    <Container className={`mb-3 mb-md-5 px-4 ${className}`} fluid onClick={onClick}>
      <Swiper {...GALLERY_SETTINGS}>
        {images.map((img, i) => (
          <SwiperSlide key={i}>
            <div className="slider-image-container" key={i + 1}>
              <img className="expanded-centered-image" src={img} alt={`${alt} ${i + 1}`} loading="lazy" />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      {children}
    </Container>
  );
};

ThreePartSlider.propTypes = {
  images: PropTypes.array,
  alt: PropTypes.string,
};
